import React from "react";
import { Navigate, useParams } from "react-router-dom";

export default function ProjectSiteRedirect() {
  const { projectId } = useParams();
  return <Navigate to={`/editor-web/${projectId}`} replace />;
}
